import { DashboardSharedFollowingListRestEndpointService } from '@api'
import { useUnit } from 'effector-react'
import { useQuery } from 'react-query'

import { $creatorId } from '@/models/creators.ts'
import { handleError } from '@/utils/error'

export const useGetSharedFollowerList = (options: {
  fanName?: string
  page?: number
  size?: number
}) => {
  const creatorId = useUnit($creatorId)

  const { data, isFetching, refetch } = useQuery({
    queryKey: ['shared-followers', creatorId, options],
    queryFn: () =>
      DashboardSharedFollowingListRestEndpointService.dashboardGetSharedFollowingListFans(
        options,
      ),
    enabled: !!creatorId,
    onError: (error) =>
      handleError(error, 'Failed to get shared follower list', refetch),
  })

  return { data, isFetching, refetch }
}
